function _slicedToArray(arr, i) {return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();}function _nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr, i) {var _arr = [];var _n = true;var _d = false;var _e = undefined;try {for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}function _arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * Dashboard
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * @namespace gplans.dashboard.services
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    */
(function () {
  'use strict';
  angular.
  module('gplans.dashboard.services').
  factory('Mealplan', Mealplan);Mealplan.$inject = ["Profile", "$rootScope", "$q", "$firebaseObject", "ggTypes", "MeasurementSystem", "AppVersionChanged"];

  function Mealplan(Profile, $rootScope, $q, $firebaseObject, ggTypes, MeasurementSystem, AppVersionChanged) {
    "ngInject";

    var _myMealPlan;
    var _params = ['calories', 'carbohydrates', 'fats', 'proteins'];
    var _meals_params = ['logged', 'skipped', 'planned'];
    var _onFirstUnloggedMealCallbacks = [];
    var _mSystem;
    var _myMealPlanAtWeekNumber;
    var _weekNumber;
    var _state;
    var _onFirebaseMealCallbacks = [];


    if ($rootScope.user && $rootScope.user.intercom_id) {
      _initialize($rootScope.user.intercom_id);
    } else {
      $rootScope.$watch(function () {
        return $rootScope.user && $rootScope.user.intercom_id;
      }, function (userIntercomId) {
        if (!userIntercomId) return;
        _initialize(userIntercomId);
      });
    }

    MeasurementSystem.onMeasurementSystemChanged(function (msystem) {
      updatePlans();
    });

    /*
        var watchCheckin = $rootScope.$watch(
          function(){ return $rootScope.user.last_checkin.id; },
          function(newCheckinId, oldCheckinId) {
            if(newCheckinId !== oldCheckinId && angular.isNumber(newCheckinId)) {
              getMealPlan(true);
              getMealPlanAtWeekNumber(_weekNumber, true);
            }
          }
        );
        */

    addMealToFirebase = decorateMealArgument(addMealToFirebase);
    updateMealInFirebase = decorateMealArgument(updateMealInFirebase);
    updateOrCreateMealInFirebase = decorateMealArgument(updateOrCreateMealInFirebase);
    removeMealFromFirebase = decorateMealArgument(removeMealFromFirebase);


    var Mealplan = {
      logMeal: logMeal,
      skipMeal: skipMeal,
      unlogMeal: unlogMeal,
      getMealPlan: getMealPlan, // for some day or week
      createSwap: createSwap,
      removeSwap: 0,
      addMealItem: addMealItem,
      removeMealItem: removeMealItem,
      removeAllMealItem: removeAllMealItem,
      updateMealItem: updateMealItem, // todo: probably we could replace create / remove Swap with this one
      // maybe will be good to have some additional function to get only some stats
      // definitely we'll need calories tracked stats on measurements page
      getTrackedCalories: 0, // for some day or week
      getFirstUnloggedMeal: getFirstUnloggedMeal,
      onFirstUnloggedMealChanged: onFirstUnloggedMealChanged,
      getMealPlanAtWeekNumber: getMealPlanAtWeekNumber,
      setState: setState,
      updateMealItemForAllWeek: updateMealItemForAllWeek,
      updatePlans: updatePlans,
      addExtraMealItems: addExtraMealItems,
      addMealToFirebase: addMealToFirebase,
      updateMealInFirebase: updateMealInFirebase,
      removeMealFromFirebase: removeMealFromFirebase,
      updateOrCreateMealInFirebase: updateOrCreateMealInFirebase,
      removeAllMealItemsFromFirebase: removeAllMealItemsFromFirebase,
      firebaseMeals: {} };


    return Mealplan;

    function _initialize(intercomId) {
      if (_initialize.initialized) return;
      _initialize.initialized = true;

      var ref = firebase.database().ref().
      child("users").
      child(intercomId).
      child("user_meals");

      ref.on('value', function (snap) {
        console.warn('mealplans.service - ref() value changed', snap.val());
        $rootScope.$applyAsync(function () {
          Mealplan.firebaseMeals = angular.copy(snap.val()) || {};
        });
      });

      ref.on('child_added', function (childSnapshot, prevChildKey) {
        console.warn('mealplans.service - ref() child_added', childSnapshot.val(), prevChildKey);
      });

      ref.on('child_removed', function (oldChildSnapshot) {
        console.warn('mealplans.service - ref() child_removed', oldChildSnapshot.val());
      });

      ref.on('child_changed', function (childSnapshot, prevChildKey) {
        console.warn('mealplans.service - ref() child_changed', childSnapshot.val(), prevChildKey);
      });

      ref.on('child_moved', function (childSnapshot, prevChildKey) {
        console.warn('mealplans.service - ref() child_moved', childSnapshot.val(), prevChildKey);
      });


    }

    function updatePlans() {
      var req1 = getMealPlan(true);
      var req2 = getMealPlanAtWeekNumber(_weekNumber, true);
      var req = $q.all([req1, req2]);
      return req;
    }

    function _fireOnFirebaseMealChangedCallbacks(data) {
      _onFirebaseMealCallbacks.forEach(function (cb) {
        if (angular.isFunction(cb)) {
          cb(data);
        }
      });
    }

    function _fireOnFirstUnloggedMealCallbacks(data) {
      _onFirstUnloggedMealCallbacks.forEach(function (cb) {
        if (angular.isFunction(cb)) {
          cb(data);
        }
      });
    }

    function onFirstUnloggedMealChanged(callback) {
      // call when external change has happened
      var idx = _onFirstUnloggedMealCallbacks.push(callback) - 1;

      // return unsubscribe function
      var unsub = function unsub() {
        delete _onFirstUnloggedMealCallbacks[idx];
      };
      return unsub;
    }

    // get calories, carbohydrates, fats, proteins inside meal
    function _get_param_meal(mealPlan, dayIndex, mealIndex, meals_param, param) {
      if (meals_param == 'logged')
      return mealPlan.days[dayIndex].meals[mealIndex].logged_meal_items.reduce(function (res, item) {
        if (item[param] === null) item[param] = 0;
        return res + parseFloat(item[param]);
      }, 0);else
      if (!mealPlan.days[dayIndex].meals[mealIndex].skipped && meals_param == 'skipped') return 0;else

      return mealPlan.days[dayIndex].meals[mealIndex].meal_items.reduce(function (res, item) {
        if (item[param] === null) item[param] = 0;
        return res + parseFloat(item[param]);
      }, 0);
    }

    // get calories, carbohydrates, fats, proteins inside day
    function _get_param_day(mealPlan, dayIndex, meals_param) {
      return mealPlan.days[dayIndex].meals.reduce(function (res, item) {
        return res + parseFloat(item[meals_param]);
      }, 0);
      /*
             return mealPlan.days[dayIndex].meals.reduce(function (res, item) {
               if (meals_param === _meals_params[2] && item[param] !== null) {
                 return res + parseFloat(item[param]);
               }
               else if (item[meals_param] && item[param] !== null) {
                 return res + parseFloat(item[param]);
               }
               else return res;
             }, 0);*/
    }

    // get calories, carbohydrates, fats, proteins total
    function _get_param_total(mealPlan, meals_param) {
      return mealPlan.days.reduce(function (res, item) {
        return res + parseFloat(item[meals_param]);
      }, 0);
    }

    function _calculate_params(mealPlan, dayIndex, mealIndex) {
      for (var i = 0; i < _meals_params.length; i++) {
        for (var j = 0; j < _params.length; j++) {
          for (var k = 0; k < mealPlan.days[dayIndex].meals.length; k++) {
            mealPlan.days[dayIndex].meals[k][_meals_params[i] + '_meal_' + _params[j]] = _get_param_meal(mealPlan, dayIndex, k, _meals_params[i], _params[j]);
          }
        }
      }
      for (i = 0; i < _meals_params.length; i++) {
        for (j = 0; j < _params.length; j++) {
          mealPlan.days[dayIndex][_meals_params[i] + '_meals_' + _params[j]] = _get_param_day(mealPlan, dayIndex, _meals_params[i] + '_meal_' + _params[j]);
          mealPlan[_meals_params[i] + '_meals_' + _params[j]] = _get_param_total(mealPlan, _meals_params[i] + '_meals_' + _params[j]);
        }
      }
      return mealPlan;
    }

    function _setAmount(mealPlan) {
      try {
        for (var k = 0; k < mealPlan.days.length; k++) {
          var day = mealPlan.days[k];
          for (var i = 0; i < day.meals.length; i++) {
            var meal = day.meals[i];
            var firebase_meal = Mealplan.firebaseMeals && Mealplan.firebaseMeals[meal.id];
            if (firebase_meal && firebase_meal.meal_object && firebase_meal.meal_object.meal_items) {
              firebase_meal.meal_object || (firebase_meal.meal_object = {});
              day.meals[i] = angular.copy(firebase_meal.meal_object);
              if (firebase_meal.meal_object.extra_items) {
                day.meals[i].meal_items = day.meals[i].meal_items.
                concat(firebase_meal.meal_object.extra_items);
              }
              day.meals[i].logged_meal_items = [];
            }

            for (var j = 0; j < meal.meal_items.length; j++) {
              if (_mSystem === 'SI') {
                mealPlan.days[k].meals[i].meal_items[j].amount =
                parseFloat(mealPlan.days[k].meals[i].meal_items[j].portion_si) * parseFloat(mealPlan.days[k].meals[i].meal_items[j].exchanges);
              } else
              {
                mealPlan.days[k].meals[i].meal_items[j].amount =
                parseFloat(mealPlan.days[k].meals[i].meal_items[j].portion) * parseFloat(mealPlan.days[k].meals[i].meal_items[j].exchanges);
              }
            }
            for (var j = 0; j < meal.logged_meal_items.length; j++) {
              if (_mSystem === 'SI') {
                mealPlan.days[k].meals[i].logged_meal_items[j].amount =
                parseFloat(mealPlan.days[k].meals[i].logged_meal_items[j].portion_si) * parseFloat(mealPlan.days[k].meals[i].logged_meal_items[j].exchanges);
              } else
              {
                mealPlan.days[k].meals[i].logged_meal_items[j].amount =
                parseFloat(mealPlan.days[k].meals[i].logged_meal_items[j].portion) * parseFloat(mealPlan.days[k].meals[i].logged_meal_items[j].exchanges);
              }
            }
          }
        }
      } catch (e) {
        console.warn(e);
      }
      return mealPlan;
    }

    function getFirstUnloggedMeal() {
      var m = null,
      meals = _myMealPlan.days[$rootScope.user.last_checkin.day - 1].meals,
      mealsLen = meals.length;
      var i = 0;
      if (meals && mealsLen > 0) {
        meals.some(function (meal) {
          if (!meal.logged && !meal.skipped) {
            m = meal;
            return true;
          }
          i++;
        });
        if (m && m.meal_items && m.meal_items.length)
        for (var j = 0; j < m.meal_items.length; j++) {
          if (_mSystem === 'SI') {
            m.meal_items[j].amount =
            parseFloat(m.meal_items[j].portion_si) * m.meal_items[j].exchanges;
          } else
          {
            m.meal_items[j].amount =
            parseFloat(m.meal_items[j].portion) * m.meal_items[j].exchanges;
          }
        }
      }
      var data = {
        firstTodayUnlogedMeal: m,
        firstTodayUnlogedMealIndex: i };

      _fireOnFirstUnloggedMealCallbacks(data);
      return data;
    }

    function getMealPlanAtWeekNumber(weekNumber, forceUpdate) {
      if (_myMealPlanAtWeekNumber && !angular.isDefined(forceUpdate) && weekNumber == _weekNumber) {
        return $q.resolve(angular.copy(_myMealPlanAtWeekNumber));
      } else
      {
        _weekNumber = weekNumber;
        var reqMSytem = MeasurementSystem.getMeasurementSystem();
        var reqMyMealPlan = Profile.getMyMealplan({ 'week_number': _weekNumber });
        var req = $q.all([
        reqMSytem,
        reqMyMealPlan]).
        then(function (res) {
          _mSystem = res[0];
          _myMealPlanAtWeekNumber = res[1].data;
          _myMealPlanAtWeekNumber = _setAmount(_myMealPlanAtWeekNumber);
          return angular.copy(_myMealPlanAtWeekNumber);
        });

        return req;
      }
    }

    function getMealPlan(forceUpdate) {
      if (_myMealPlan && !angular.isDefined(forceUpdate)) {
        return $q.resolve(angular.copy(_myMealPlan));
      } else
      {
        var reqMSytem = MeasurementSystem.getMeasurementSystem();
        var reqMyMealPlan = Profile.getMyMealplan();
        var req = $q.all([
        reqMSytem,
        reqMyMealPlan]).
        then(function (res) {
          _mSystem = res[0];
          _myMealPlan = res[1].data;
          _myMealPlan = _setAmount(_myMealPlan);
          //getFirstUnloggedMeal();
          return angular.copy(_myMealPlan);
        });

        return req;
      }
    }

    function logMeal(meal, dayIndex, mealIndex) {
      var obj = {
        meal: meal.id,
        checkin: $rootScope.user.last_checkin.id };


      var req = Profile.createLoggedMeal(obj).then(function (res) {

        //_myMealPlan.days[dayIndex].meals[mealIndex] = meal;
        _myMealPlan.days[dayIndex].meals[mealIndex].logged = true;
        _myMealPlan.days[dayIndex].logged_meals_number += 1;
        _myMealPlan.logged_meals_number += 1;
        _myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_id = res.data.id;
        _myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_items =
        //angular.copy(_myMealPlan.days[dayIndex].meals[mealIndex].meal_items);
        angular.copy(meal.meal_items);
        var objs = [],mealItems = meal.meal_items;
        var logged_meal_calories = 0;
        for (var i = 0; i < mealItems.length; i++) {
          if (mealItems[i].deleted) continue;
          if (Number(mealItems[i].amount) > 0) {
            var n = ggTypes.Nutritionable(mealItems[i]);
            n.name = mealItems[i].name;
            n.logged_meal = res.data.id;
            if (_mSystem === 'SI')
            n.exchanges = parseFloat(mealItems[i].amount / mealItems[i].portion_si).toFixed(2);else

            n.exchanges = parseFloat(mealItems[i].amount / mealItems[i].portion).toFixed(2);
            n.portion_si = mealItems[i].portion_si;
            n.unit_si = mealItems[i].unit_si;
            n.calories = parseFloat(mealItems[i].calories * n.exchanges / mealItems[i].exchanges).toFixed(2);
            n.carbohydrates = parseFloat(mealItems[i].carbohydrates * n.exchanges / mealItems[i].exchanges).toFixed(2);
            n.fats = parseFloat(mealItems[i].fats * n.exchanges / mealItems[i].exchanges).toFixed(2);
            n.proteins = parseFloat(mealItems[i].proteins * n.exchanges / mealItems[i].exchanges).toFixed(2);
            objs.push(n);
            _myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_items[i].amount = mealItems[i].amount;
            _myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_items[i].exchanges = n.exchanges;
            _myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_items[i].calories = n.calories;
            _myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_items[i].carbohydrates = n.carbohydrates;
            _myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_items[i].fats = n.fats;
            _myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_items[i].proteins = n.proteins;
            logged_meal_calories += parseFloat(n.calories);
          }
        }
        //_myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_calories = logged_meal_calories;
        var req = Profile.createLoggedMealItem(objs).then(function (res) {
          _myMealPlan = _calculate_params(_myMealPlan, dayIndex, mealIndex);
          getFirstUnloggedMeal();
          removeMealFromFirebase(meal);
          return angular.copy(_myMealPlan);
        });

        return req;
      }, function (err) {
        // {"logged_meal_error":"Logged meal already exist"}
        handleLogMealError(err);
        throw err;
      });
      return req;
    }

    function skipMeal(meal, dayIndex, mealIndex) {
      var obj = {
        meal: meal.id,
        checkin: $rootScope.user.last_checkin.id };

      obj.skipped = 'True';

      var req = Profile.createLoggedMeal(obj).then(function (res) {
        //_myMealPlan.days[dayIndex].meals[mealIndex] = meal;
        _myMealPlan.days[dayIndex].meals[mealIndex].skipped = true;
        _myMealPlan.days[dayIndex].skipped_meals_number += 1;
        _myMealPlan.skipped_meals_number += 1;
        _myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_id = res.data.id;
        /*
                                                                                  for(var i=0; i < mealItems.length; i++) {
                                                                                      _myMealPlan.days[dayIndex].meals[mealIndex].meal_items[i].amount = meal.meal_items[i].amount;
                                                                                  }
                                                                                  */
        _myMealPlan = _calculate_params(_myMealPlan, dayIndex, mealIndex);
        getFirstUnloggedMeal();
        return angular.copy(_myMealPlan);
      }, function (err) {
        handleLogMealError(err);
        throw err;
      });
      return req;
    }

    function unlogMeal(meal, dayIndex, mealIndex) {
      var req = Profile.destroyLoggedMeal(meal).
      then(function () {
        if (meal.skipped) {
          _myMealPlan.days[dayIndex].meals[mealIndex].skipped = false;
          _myMealPlan.days[dayIndex].skipped_meals_number -= 1;
          _myMealPlan.skipped_meals_number -= 1;
        }
        if (meal.logged) {
          _myMealPlan.days[dayIndex].meals[mealIndex].logged = false;
          _myMealPlan.days[dayIndex].logged_meals_number -= 1;
          _myMealPlan.logged_meals_number -= 1;
          _myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_items = [];
        }
        var meal_item;
        for (var i = 0; i < _myMealPlan.days[dayIndex].meals[mealIndex].meal_items.length; i++) {
          meal_item = _myMealPlan.days[dayIndex].meals[mealIndex].meal_items[i];
          if (_mSystem === 'SI')
          meal_item.amount = meal_item.exchanges * meal_item.portion_si;else

          meal_item.amount = meal_item.exchanges * meal_item.portion;
        }
        _myMealPlan = _calculate_params(_myMealPlan, dayIndex, mealIndex);
        getFirstUnloggedMeal();
        return angular.copy(_myMealPlan);
      }).
      catch(function (err) {
        handleLogMealError(err);
        throw err;
      });

      return req;
    }

    function createSwap(selectedFood, mealItem, day, dayIndex, mealIndex, foodIndex) {
      var data = {
        replace: mealItem.id,
        replace_with: selectedFood.id,
        checkin: $rootScope.user.last_checkin.id,
        day: day };

      var req = Profile.createSwap(data).then(function (res) {
        var mealItem = _myMealPlan.days[dayIndex].meals[mealIndex].meal_items[foodIndex];
        mealItem.sample_food = selectedFood; // TODO!!!
        mealItem.amount = mealItem.portion * mealItem.exchanges;

        getFirstUnloggedMeal();
        _myMealPlan = _calculate_params(_myMealPlan, dayIndex, mealIndex);
        return angular.copy(_myMealPlan);

      });
      return req;
    }

    function addMealItem(food, dayIndex, mealIndex) {
      var meal = _myMealPlan.days[dayIndex].meals[mealIndex];
      var mealItem = {
        //amount: _mSystem === 'SI' ? food.exchanges * food.portion_si : food.exchanges * food.portion,
        amount: _mSystem === 'SI' ? food.portion_si : food.portion,
        category: food.category,
        exchanges: 1,
        name: food.name,
        // sample_food: food,
        calories: food.calories, // TODO: copy nutritionable params
        carbohydrates: food.carbohydrates,
        fats: food.fats,
        groceries_replacement_ratio: food.groceries_replacement_ratio,
        groceries_unit: food.groceries_unit,
        // todo: check
        portion: food.portion,
        portion_si: food.portion_si,
        proteins: food.proteins,
        subcategory: food.subcategory,
        unit: food.unit,
        unit_si: food.unit_si,
        // TODO meal is temporary
        meal: meal.id };

      var req = Profile.addMealItem(mealItem).then(function (res) {
        mealItem.id = res.data.id;
        _myMealPlan.days[dayIndex].meals[mealIndex].meal_items.push(mealItem);
        _myMealPlan = _calculate_params(_myMealPlan, dayIndex, mealIndex);
        return angular.copy(_myMealPlan);
      });
      return req;
    }

    function removeAllMealItem(dayIndex, mealIndex) {
      var meals = _myMealPlan.days[dayIndex].meals[mealIndex].meal_items;
      var promises = meals.map(function (meal) {
        return Profile.destroyMealItem(meal);
      });
      return $q.all(promises).then(function (res) {
        _myMealPlan.days[dayIndex].meals[mealIndex].meal_items = [];
        _myMealPlan.days[dayIndex].meals[mealIndex].calories = 0;
        _myMealPlan.days[dayIndex].meals[mealIndex].carbohydrates = 0;
        _myMealPlan.days[dayIndex].meals[mealIndex].fats = 0;
        _myMealPlan.days[dayIndex].meals[mealIndex].proteins = 0;
        _myMealPlan = _calculate_params(_myMealPlan, dayIndex, mealIndex);
        return angular.copy(_myMealPlan);
      });
    }

    function removeMealItem(dayIndex, mealIndex, foodIndex) {
      var meal = _myMealPlan.days[dayIndex].meals[mealIndex].meal_items[foodIndex];
      var req = Profile.destroyMealItem(meal).then(function (res) {
        _myMealPlan.days[dayIndex].meals[mealIndex].meal_items.splice(foodIndex, 1);
        _myMealPlan = _calculate_params(_myMealPlan, dayIndex, mealIndex);
        return angular.copy(_myMealPlan);
      });
      return req;
    }

    function addMealToFirebase(meal) {
      var mealCopy = angular.copy(meal);
      var newFireBaseMeal = {
        version_num: 1,
        meal_object: mealCopy };


      firebase.database().ref().
      child("users").
      child($rootScope.user.intercom_id).
      child("user_meals").
      child(mealCopy.id).
      set(newFireBaseMeal);

    }

    function updateMealInFirebase(meal) {
      var mealCopy = angular.copy(meal);
      //firebase.database().ref().child("users").child($rootScope.user.intercom_id).child("user_meals").child(meal.id).child("meal_object").set(meal);
      var firebase_meal = Mealplan.firebaseMeals[mealCopy.id];
      if (firebase_meal) {
        var firebase_meal_version = firebase_meal.version_num;
        if (!firebase_meal_version) firebase_meal_version = 0;
        firebase_meal_version += 1;
        firebase_meal = firebase_meal.meal_object;
        firebase_meal.meal_items = mealCopy.meal_items;
        firebase_meal.extra_items = mealCopy.extra_items;
        var firebase_meal_object = {
          meal_object: firebase_meal,
          version_num: firebase_meal_version };

        firebase.database().ref().
        child("users").
        child($rootScope.user.intercom_id).
        child("user_meals").
        child(mealCopy.id).
        set(firebase_meal_object);
      }
    }

    function removeMealFromFirebase(meal) {
      firebase.database().ref().
      child("users").
      child($rootScope.user.intercom_id).
      child("user_meals").
      child(meal.id).
      remove();

    }

    function updateOrCreateMealInFirebase(meal) {
      var firebase_meal = Mealplan.firebaseMeals[meal.id];
      if (firebase_meal) {
        return updateMealInFirebase(meal);
      } else {
        return addMealToFirebase(meal);
      }
    }

    function removeAllMealItemsFromFirebase() {
      firebase.database().ref().
      child("users").
      child($rootScope.user.intercom_id).
      child("user_meals").
      remove();

    }

    function updateMealItem(food, mealItem, dayIndex, mealIndex, foodIndex) {
      if (_state == 'week')
      var meal = _myMealPlan.days[dayIndex].meals[mealIndex];else

      var meal = _myMealPlanAtWeekNumber.days[dayIndex].meals[mealIndex];
      var _mealItem = {
        id: mealItem.id,
        amount: _mSystem === 'SI' ? food.portion_si * mealItem.exchanges : food.portion * mealItem.exchanges,
        category: food.category,
        exchanges: mealItem.exchanges,
        name: food.name,
        calories: parseFloat(food.calories * mealItem.exchanges).toFixed(2), // TODO: copy nutritionable params
        carbohydrates: parseFloat(food.carbohydrates * mealItem.exchanges).toFixed(2),
        fats: parseFloat(food.fats * mealItem.exchanges).toFixed(2),
        groceries_replacement_ratio: food.groceries_replacement_ratio,
        groceries_unit: food.groceries_unit,
        portion: food.portion,
        portion_si: food.portion_si,
        proteins: parseFloat(food.proteins * mealItem.exchanges).toFixed(2),
        subcategory: food.subcategory,
        unit: food.unit,
        unit_si: food.unit_si,
        // TODO meal is temporary
        meal: meal.id };

      var req = Profile.updateMealItem(_mealItem).then(function (res) {
        if (_state == 'week') {
          _myMealPlan.days[dayIndex].meals[mealIndex].meal_items[foodIndex] = _mealItem;
          getFirstUnloggedMeal();
          _myMealPlan = _calculate_params(_myMealPlan, dayIndex, mealIndex);
          updateMealInFirebase(meal);
          return angular.copy(_myMealPlan);
        } else
        {
          _myMealPlanAtWeekNumber.days[dayIndex].meals[mealIndex].meal_items[foodIndex] = _mealItem;
          _myMealPlanAtWeekNumber = _calculate_params(_myMealPlanAtWeekNumber, dayIndex, mealIndex);
          updateMealInFirebase(meal);
          return angular.copy(_myMealPlanAtWeekNumber);
        }
      });
      return req;
    }

    function updateMealItemForAllWeek(food, mealItem, dayIndex, mealIndex, foodIndex) {
      if (_state == 'week')
      var mealplan = angular.copy(_myMealPlan);else

      var mealplan = angular.copy(_myMealPlanAtWeekNumber);
      var reqs = [];
      for (var i = 0; i < 7; i++) {
        var meal = mealplan.days[i].meals[mealIndex];
        var mealItemToChange = null;
        var mealItemToChangeIndex = null;
        for (var j = 0; j < meal.meal_items.length; j++) {
          var oldMealItem = meal.meal_items[j];
          if (oldMealItem.category == mealItem.category && oldMealItem.name == mealItem.name) {
            mealItemToChange = oldMealItem;
            mealItemToChangeIndex = j;
          }
        }
        if (mealItemToChange !== null && mealItemToChangeIndex !== null) {
          var _mealItem = {
            id: mealItemToChange.id,
            amount: _mSystem === 'SI' ? food.portion_si * mealItemToChange.exchanges : food.portion * mealItemToChange.exchanges,
            category: food.category,
            exchanges: mealItemToChange.exchanges,
            name: food.name,
            calories: parseFloat(food.calories * mealItemToChange.exchanges).toFixed(2),
            carbohydrates: parseFloat(food.carbohydrates * mealItemToChange.exchanges).toFixed(2),
            fats: parseFloat(food.fats * mealItemToChange.exchanges).toFixed(2),
            groceries_replacement_ratio: food.groceries_replacement_ratio,
            groceries_unit: food.groceries_unit,
            portion: food.portion,
            portion_si: food.portion_si,
            proteins: parseFloat(food.proteins * mealItemToChange.exchanges).toFixed(2),
            subcategory: food.subcategory,
            unit: food.unit,
            unit_si: food.unit_si,
            meal: meal.id };

          reqs.push(Profile.updateMealItem(_mealItem));
          mealplan.days[i].meals[mealIndex].meal_items[mealItemToChangeIndex] = _mealItem;
          _calculate_params(mealplan, i, mealIndex);
          updateMealInFirebase(meal);
        }
      }
      return $q.all(reqs).then(function (res) {
        if (_state == 'week')
        _myMealPlan = angular.copy(mealplan);else

        _myMealPlanAtWeekNumber = angular.copy(mealplan);
        return angular.copy(mealplan);
      });
    }

    function setState(state) {
      _state = state;
    }

    function addExtraMealItems(foods, dayIndex) {
      if (foods.length) {
        var meal_length = _myMealPlan.days[dayIndex].meals.length;
        var last_meal = _myMealPlan.days[dayIndex].meals[meal_length - 1];
        var week_number = last_meal.week_number;
        var meal_plan_id = last_meal.meal_plan;
        var day_number = dayIndex + 1;
        var mealIndex = meal_length - 1;
        var mealItems = [];
        for (var i = 0; i < foods.length; i++) {
          var food = foods[i];
          var mealItem = {
            amount: _mSystem === 'SI' ? food.portion_si : food.portion,
            category: food.category,
            exchanges: 1,
            name: food.name,
            // sample_food: food,
            calories: food.calories, // TODO: copy nutritionable params
            carbohydrates: food.carbohydrates,
            fats: food.fats,
            groceries_replacement_ratio: 1,
            groceries_unit: food.groceries_unit,
            // todo: check
            portion: food.portion,
            portion_si: food.portion_si,
            proteins: food.proteins,
            subcategory: food.subcategory,
            unit: food.unit,
            unit_si: food.unit_si };

          mealItems.push(mealItem);
        }
        var req = Profile.addExtraMealItem(mealItems, day_number, week_number).then(function (res) {
          var meal_id = res.data[0].meal_id;
          var logged_meal_id = res.data[0].logged_meal_id;
          if (last_meal.id == meal_id && last_meal.label == 'Extra food') {
            for (var i = 0; i < res.data.length; i++) {
              res.data[i].amount = _mSystem === 'SI' ? food.portion_si : food.portion;
              last_meal.logged_meal_items.push(res.data[i]);
            }
            last_meal.logged = true;
            last_meal.logged_meal_id = logged_meal_id;
          } else
          {
            var new_meal = {
              label: 'Extra food',
              image: 'https://gplans.storage.googleapis.com/media/meals/2016/06/24/b8.jpg',
              day_number: day_number,
              week_number: week_number,
              meal_plan: meal_plan_id,
              meal_items: [],
              logged_meal_items: [],
              id: meal_id,
              logged: true,
              meal_number: meal_length + 1,
              logged_meal_id: logged_meal_id };

            for (var i = 0; i < res.data.length; i++) {
              res.data[i].amount = _mSystem === 'SI' ? food.portion_si : food.portion;
            }
            new_meal.logged_meal_items = res.data;
            _myMealPlan.days[dayIndex].meals.push(new_meal);
            mealIndex = meal_length;
          }
          /*
             var logged_meal_calories = 0;
             for(var i=0; i <  _myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_items.length; i++){
             var n = _myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_items[i];
             logged_meal_calories += parseFloat(n.calories);
             }
             _myMealPlan.days[dayIndex].meals[mealIndex].logged_meal_calories = logged_meal_calories;
             */
          _myMealPlan = _calculate_params(_myMealPlan, dayIndex, mealIndex);
          _myMealPlan.planned_meals_number += 1;
          _myMealPlan.days[dayIndex].planned_meals_number += 1;
          return angular.copy(_myMealPlan);
        });
        return req;
      } else
      return $q.resolve(_myMealPlan);
    }

    function handleLogMealError() {var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      err.data || (err.data = {});
      if (
      err.data.logged_meal_error && err.data.logged_meal_error.toLowerCase() === "logged meal already exist" ||
      err.data.detail && err.data.detail.toLowerCase() === "not found.")
      {
        AppVersionChanged.showRefreshModal();
      } else {
        alert('Something wrong with your data, please reload the page and try again');
      }
    }
  }
})();var



FirebaseMeal = /*#__PURE__*/function () {_createClass(FirebaseMeal, null, [{ key: "defaults", get: function get()

    {
      return {
        calories: 0,
        carbohydrates: 0,
        cardClass: "",
        day_number: 0,
        extra_items: [],
        fats: 0,
        id: 0,
        image: {},
        label: "",
        logConfirmShowing: 0,
        logged_meal_calories: 0,
        logged_meal_id: 0,
        meal_items: [],
        meal_number: 0,
        meal_plan: 0,
        proteins: 0,
        week_number: 0,
        logged_meal_items: [] };

    } }]);

  function FirebaseMeal() {var mealData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};_classCallCheck(this, FirebaseMeal);
    Object.assign(this, mealData instanceof this.constructor ?
    mealData :
    this.parse(mealData));

  }_createClass(FirebaseMeal, [{ key: "parse", value: function parse(

    mealData) {
      var meal = Object.assign({},
      FirebaseMeal.defaults,
      angular.copy(mealData));var _meal$meal_items$redu =


      meal.meal_items.
      reduce(function (_ref, someItem, i) {var _ref2 = _slicedToArray(_ref, 2),mealItems = _ref2[0],extraItems = _ref2[1];
        switch (someItem.category) {
          case "extra":
          case "free":
            extraItems.push(someItem);
            break;

          default:
            mealItems.push(someItem);}

        return [mealItems, extraItems];
      }, [[], []]),_meal$meal_items$redu2 = _slicedToArray(_meal$meal_items$redu, 2),mealItems = _meal$meal_items$redu2[0],extraItems = _meal$meal_items$redu2[1];

      meal.meal_items = mealItems;
      meal.extra_items = extraItems;

      return meal;
    } }]);return FirebaseMeal;}();


function decorateMealArgument(fn) {var argMealIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;var ctx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function () {for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}

    console.warn('undecorated  meal', args[argMealIndex]);
    var meal = new FirebaseMeal(args[argMealIndex]);
    console.warn('decorated meal', meal);

    args[argMealIndex] = meal;

    return fn.apply(ctx, args);
  };
}